import { Field, useFormikContext } from 'formik';
import React, { FC, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocale } from '../../contexts/localeContext';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import deleteIcon from '../../images/Delete.svg';
import { IAppState } from '../../store/types';
import { validateEndTime, validateItemName, validateStartTime } from '../../utilities/Validation';
import EntityHierarchy from '../entityHierarchy/entityHierarchy';
import Label from '../label/label';
import TimeField from '../timeField/timeField';
import useFocusOnRouteChange from '../../hooks/useFocusOnRouteChange';

export const AccessTimePatternCard: FC = () => {
    const { errors, values, setFieldValue, validateField } = useFormikContext<any>();
    const site = useSelector((state: IAppState) => state.site.site.label)
    const { translate } = useLocale();
    const [startTimeHovered, setStartTimeHovered] = useState(false);
    const [endTimeHovered, setEndTimeHovered] = useState(false);

    const inputRef = useRef<HTMLInputElement>(null);
    useFocusOnRouteChange(inputRef);

    useEffect(() => {
        if (values.endTime || values.startTime || values.endTime === "" || values.startTime == "") {
            validateField("startTime");
            validateField("endTime");
        }
    }, [values.startTime, values.endTime])

    return <>
        <div className="w-full p-2 inline-flex justify-start items-center bg-white">
            {values.id
                ? <div className="ml-8 mr-5 card-details">
                    <EntityHierarchy title={values.name} tree={{ label: values.site, node: { label: values.name } }} />
                </div>
                : null}
            <div className="flex flex-col py-4 px-8">
                <div className="mb-1 mr-6">
                    <div className="flex flex-row justify-between" id = 'nameLabel'>
                        <Label
                            htmlFor="name"
                            className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.name)}:</Label>
                        {errors.name ? <span className='text-red-600 text-xs'>{errors.name}</span> : null}
                    </div>
                    <Field
                        id="nameInput"
                        type="text"
                        name="name"
                        innerRef={inputRef}
                        className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm w-full bg-gray-input"
                        validate={(value) => validateItemName(value, translate)}/>
                </div>
                <div className="flex flex-row justify-between"  id = 'startTimeLabel'>
                    <Label
                        htmlFor="startTime"
                        className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.startTime)}:</Label>
                    {errors.startTime ? <span className='text-red-600 text-xs'>{errors.startTime}</span> : null}
                </div>
                <div className="flex flex-row justify-between" id='startTimeId'>
                    <Field
                        name="startTime"
                        valueName="startTime"
                        component={TimeField}
                        validate={(value) => validateStartTime(value, values.endTime, translate)} />
                    <div className="flex relative w-6 ml-1"
                        onMouseEnter={() => setStartTimeHovered(true)}
                        onMouseLeave={() => setStartTimeHovered(false)}
                        onClick={(e) => setFieldValue("startTime", "")}>
                        <div className="absolute bottom-0 mb-1 right-0 cursor-pointer">
                            {startTimeHovered
                                ? <img src={deleteIcon} alt="" />
                                : <img src={deleteIcon} alt="" />
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex flex-col py-4 px-8 ">
                <div className="mb-1 mr-6">
                    <div className="flex flex-row justify-between">
                        <Label
                            htmlFor="siteId"
                            className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.site)}:</Label>
                        {errors.siteId ? <span className='text-red-600 text-xs'>{errors.siteId}</span> : null}
                    </div>
                    {values.id
                        ? <Field
                            value={values.site}
                            disabled={true}
                            className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-500 text-sm bg-gray-input w-full cursor-not-allowed" />
                        : <Field
                            value={site}
                            disabled={true}
                            className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-500 text-sm bg-gray-input w-full cursor-not-allowed" />}
                </div>
                <div className="flex flex-row justify-between" id = 'endTimeLabel'>
                    <Label
                        htmlFor="endTime"
                        className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.endTime)}:</Label>
                    {errors.endTime ? <span className='text-red-600 text-xs'>{errors.endTime}</span> : null}
                </div>
                <div className="flex flex-row justify-between" id='endTimeId'>
                 <Field
                        name="endTime"
                        valueName="endTime"
                        component={TimeField}
                        validate={(value) => validateEndTime(values.startTime, value, translate)} />
                    <div className="flex relative w-6 ml-1"
                        onMouseEnter={() => setEndTimeHovered(true)}
                        onMouseLeave={() => setEndTimeHovered(false)}
                        onClick={(e) => setFieldValue("endTime", "")}>
                        <div className="absolute bottom-0 mb-1 right-0 cursor-pointer">
                            {endTimeHovered
                                ? <img src={deleteIcon} alt="" />
                                : <img src={deleteIcon} alt="" />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>;
};

